import Alpine from 'alpinejs';
import { RecommendationStore } from './recommendation';
import { RecommendationStoreAdapter } from './storeAdapter';

export const getRecommendationStore = (): RecommendationStore => {
    if (!Alpine.store('recommendation')) {
        const adapter = new RecommendationStoreAdapter();
        Alpine.store('recommendation', new RecommendationStore(adapter));
    }

    return Alpine.store('recommendation') as RecommendationStore;
};
